import { NgModule, LOCALE_ID, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import {
  APP_BASE_HREF,
  PlatformLocation,
  registerLocaleData,
} from '@angular/common';
import localeJa from '@angular/common/locales/ja';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './pages/login/login.component';
import {
  ModalSelectComponent,
  ModalSelectWrapper,
} from './components/modal-select/modal-select.component';
import { SpinnerComponent } from './components/spinner/spinner.component';

import { SearchFieldComponent } from './components/search-field/search-field.component';
import { StaffItemComponent } from './components/staff-item/staff-item.component';
import { StaffSearchComponent } from './components/staff-search/staff-search.component';
import { UserItemComponent } from './components/user-item/user-item.component';
import { UserSearchComponent } from './components/user-search/user-search.component';
import { UserInGroupSearchComponent } from './components/user-in-group-search/user-in-group-search.component';
import { SearchGroupFieldComponent } from './components/search-group-field/search-group-field.component';

import { UnitSelectComponent } from './pages/unit-select/unit-select.component';
import { AliasSelectComponent } from './pages/alias-select/alias-select.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';

import { environment } from 'src/environments/environment';

import { NgxsModule } from '@ngxs/store';
import { NgxsStoragePluginModule } from '@ngxs/storage-plugin';
import { ScheduleState } from './store/schedule/schedule.state';
import { SpinnerState } from './store/spinner/spinner.state';
import { AuthState } from './store/auth/auth.state';
import { SettingState } from './store/setting/setting.state';

import { MainLayoutComponent } from './layout/main-layout/main-layout.component';

import { baseHref, initEra, mediaRegister } from './functions';
import { HomeModule } from './home/home.module';
import { BasicModule } from './basic/basic.module';
import { RecordModule } from './record/record.module';
import { SharedModule } from './shared/shared.module';
import { RecordState } from './store/record/record.state';
import { DataState } from './store/data/data.state';
import { ComponentsSharedModule } from './components/components-shared.module';
import { ModalState } from './store/modal/modal.state';
import { TitleState } from './store/title/title.state';
import { StaffInTeamSearchComponent } from './components/staff-in-team-search/staff-in-team-search.component';
import { RecordCreateComponent } from './pages/record-create/record-create.component';
import { ClassComponent } from './pages/record-create/class/class.component';
import { StudentRecordItemComponent } from './pages/record-create/student-record-item/student-record-item.component';
import { FormsModule } from '@angular/forms';
import { UserTitleSelectComponent } from './pages/user-title-select/user-title-select.component';
import { EraService } from './shared/eras.service';
import { FooterMenuComponent } from './pages/footer-menu/footer-menu.component';
import { MediaRegisterService } from './shared/media-register.service';
import { MediaComponent } from './media/media.component';
import { ImageComponent } from './media/image/image.component';
import { VideoComponent } from './media/video/video.component';
import { StudentListComponent } from './media/infos/student/student-list.component';
import { StudentItemComponent } from './media/infos/student/student-item/student-item.component';
import { MediaInfoComponent } from './media/infos/media/media-info.component';

registerLocaleData(localeJa);

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ModalSelectComponent,
    ModalSelectWrapper,
    SpinnerComponent,
    SearchFieldComponent,
    StaffItemComponent,
    StaffSearchComponent,
    UserItemComponent,
    UserSearchComponent,
    UnitSelectComponent,
    AliasSelectComponent,
    PageNotFoundComponent,
    MainLayoutComponent,
    UserInGroupSearchComponent,
    StaffInTeamSearchComponent,
    SearchGroupFieldComponent,
    RecordCreateComponent,
    ClassComponent,
    StudentRecordItemComponent,
    UserTitleSelectComponent,
    FooterMenuComponent,
    MediaComponent,
    ImageComponent,
    VideoComponent,
    StudentListComponent,
    StudentItemComponent,
    MediaInfoComponent
  ],
  imports: [
    FormsModule,
    BrowserModule,
    HomeModule,
    BasicModule,
    RecordModule,
    AppRoutingModule,
    HttpClientModule,
    NgxsModule.forRoot(
      [
        AuthState,
        DataState,
        SettingState,
        ScheduleState,
        RecordState,
        SpinnerState,
        ModalState,
        TitleState
      ],
      {
        developmentMode: !environment.production,
        // These Selector Settings are recommended in preparation for NGXS v4
        selectorOptions: { suppressErrors: false, injectContainerState: false },
      }
    ),
    NgxsStoragePluginModule.forRoot({
      key: [
        'auth.accessToken',
        'auth.refreshToken',
        'auth.profile',
        'setting',
        'dataState',
        'record.kirokuSetting',
      ],
    }),
    // NgxsReduxDevtoolsPluginModule.forRoot(),
    // NgxsLoggerPluginModule.forRoot(),
    SharedModule,
    ComponentsSharedModule,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'ja-JP' },
    { provide: APP_BASE_HREF, useFactory: baseHref, deps: [PlatformLocation] },
    {
      provide: APP_INITIALIZER,
      useFactory: initEra,
      deps: [EraService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: mediaRegister,
      deps: [MediaRegisterService],
      multi: true
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
